export default {
  pillars: {
    sectionTitle: 'Basetao Guides & Ressourcen',
    sectionSubtitle:
      'Praktische Leitfäden zu Tabellen, Versand, QC, Verkäufern, Sicherheit und mehr.',
    readMore: 'Leitfaden lesen',
    guide: {
      title: 'Der vollständige Basetao-Spreadsheet-Leitfaden',
      desc: 'Erstellen und nutzen Sie ein Basetao-Spreadsheet für Links, Verkäufer, QC und Versand.',
    },
    review: {
      title: 'Basetao Bewertung',
      desc: 'Wie der Basetao-Agent funktioniert, seine Stärken und Grenzen.',
    },
    shipping: {
      title: 'Basetao Versandkosten-Leitfaden',
      desc: 'Verstehen Sie, wie Versandkosten berechnet werden und wie Sie sparen.',
    },
    warehouse: {
      title: 'Basetao Lager-Leitfaden',
      desc: 'Wie Lagerung, Konsolidierung und QC im Basetao-Lager funktionieren.',
    },
    qc: {
      title: 'Basetao QC & Qualitätsprüfung',
      desc: 'Was Sie auf QC-Fotos prüfen und wie Sie Probleme früh erkennen.',
    },
    sellers: {
      title: 'Basetao vertrauenswürdige Verkäufer',
      desc: 'So bewerten und wählen Sie zuverlässige Verkäufer für Ihren Einkauf.',
    },
    coupons: {
      title: 'Basetao Gutscheine & Rabattcodes',
      desc: 'Wo Sie Rabatte finden und wie Sie sie ehrlich nutzen.',
    },
    safety: {
      title: 'Ist Basetao seriös und sicher?',
      desc: 'Praktische Schritte zum Schutz Ihres Kontos, Ihrer Zahlungen und Einkäufe.',
    },
    vs: {
      title: 'Basetao vs Superbuy Vergleich',
      desc: 'Vergleichen Sie Gebühren, Funktionen und Abläufe zweier beliebter Agenten.',
    },
    beginner: {
      title: 'Basetao Anfänger-Leitfaden',
      desc: 'Eine einfache Schritt-für-Schritt-Anleitung für Ihre erste Basetao-Bestellung.',
    },
  },
};